module.exports = __webpack_public_path__ + "static/img/アセット 21@2x.cd05827.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meal_history/アセット 21@2x.png
// module id = fHcF
// module chunks = 1